import { lockBody, unlockBody, SetVhElement } from "@plugins";

class SearchModal {
    constructor(element, trigger, options) {
        this.openTrigger = trigger;
        this.searchWindow = element;
        this.searchWindowCloseTrigger = element.querySelector(".js-close-search");
        this.searchWindowInner = element.querySelector(".js-header-search-inner");
        this.searchWindowInput = element.querySelector("input");

        this._setDefaults(options);

        const window = this;
        this.isOpen = new Proxy(this.isOpen, {
            set(target, name, val) {
                target[name] = val;
                window.searchWindow.classList[val === true ? "add" : "remove"]("active");

                return true;
            },
        });

        this._init();
    }

    _setDefaults(options) {
        const defaults = {
            isOpen: {
                state: false,
            },
            transitionDuration: 200,
        };
        Object.assign(this, defaults, options);
    }

    _init() {
        this.isOpen.state = false;
        this.searchWindow.style.setProperty("--header-search-transition-duration", `${this.transitionDuration}ms`);
        this._bindEvents();
    }

    _bindEvents() {
        this.openTrigger.addEventListener("click", () => {
            this._open();
        });

        this.searchWindowCloseTrigger.addEventListener("click", () => {
            this._close();
        });

        this.outsideClickHandler = this._handleClickOutsideSearchModal.bind(this);
    }

    _open() {
        if (this.isOpen.state) return;

        new SetVhElement(this.searchWindow);
        lockBody(this.searchWindow, { reserveScrollBarGap: true });

        setTimeout(() => {
            if (this.searchWindowInput) {
                this.searchWindowInput.focus();
            }

            document.addEventListener("click", this.outsideClickHandler);
        }, this.transitionDuration);

        this.isOpen.state = true;
    }

    _close() {
        this.isOpen.state = false;
        document.removeEventListener("click", this.outsideClickHandler);
        unlockBody();
    }

    _handleClickOutsideSearchModal(event) {
        if (!event.target.closest(".js-header-search")) {
            this._close();
        }
    }
}

const searchWindow = document.querySelector(".js-header-search");
const searchTrigger = document.querySelector(".js-open-search");

if (searchWindow && searchTrigger) {
    window.addEventListener("load", () => new SearchModal(searchWindow, searchTrigger));
}
